import React, { useState } from "react";
import ArrowBackOutlinedIcon from "@mui/icons-material/ArrowBackOutlined";
import photo from "../../../../assets/img/photo_icon.svg";
import MessageHomeowner from "../../../../assets/img/testarea input icon.svg";
import cameraIcon from "../../../../assets/img/camera icon.svg";
import RequestSubmitted from "../../../../assets/img/Request Submitted.svg";
import details from "../../../../assets/img/More Project details.svg";
import measurements from "../../../../assets/img/More Measurements.svg";
import addIocn from "../../../../assets/img/add more information.svg";

const JobResultModal = ({ isOpen, onClose }) => {
  const [selectedOption, setSelectedOption] = useState("");
  const [step, setStep] = useState(1);

  if (!isOpen) return null;

  const selectOptionAction = (option) => {
    setStep(2);
    setSelectedOption(option);
  };

  const finalSubmitAction = () => {
    setStep(3);
  };

  const handleOptionSelect = (option) => setSelectedOption(option);

  return (
    <div className="job-result-modal">
      {step === 1 && (
        <>
          <div className="modal-header">
            <div className="header-content">
              <ArrowBackOutlinedIcon
                onClick={onClose}
                style={{ cursor: "pointer" }}
              />
              <div>
                <p>Step 1 of 2</p>
                <span>Select Request Type</span>
              </div>
            </div>
            <div className="progress-bar-container">
              <div className="progress-bar-fill" style={{ width: "50%" }}></div>
            </div>
          </div>
          <div className="modal-body">
            <h6>What do you need?</h6>
            <p>Select the type of additional information you're looking for</p>
            {[
              { text: "More photos and/or videos", icon: photo },
              { text: "More Project details", icon: details },
              { text: "More Measurements", icon: measurements },            
            ].map((option, index) => (
              <div className="option" key={index}>
                <div className="d-flex align-items-center gap-3">
                  <img src={option.icon} alt="photo-icon" />
                  <span>{option.text}</span>
                </div>
                <input
                  type="radio"
                  name="option"
                  checked={selectedOption === option.text}
                  onChange={() => handleOptionSelect(option.text)}
                />
              </div>
            ))}
          </div>
          <div className="modal-footer">
            <button onClick={onClose} className="cancel-btn">
              Cancel
            </button>
            <button
              onClick={() => selectOptionAction(selectedOption)}
              className="next-btn"
              disabled={!selectedOption}
            >
              Next
            </button>
          </div>
        </>
      )}

      {step === 2 && (
        <>
          <div className="modal-header">
            <div className="header-content">
              <ArrowBackOutlinedIcon onClick={() => setStep(1)} />
              <div>
                <p>Step 2 of 2</p>
                <span>Details</span>
              </div>
            </div>
            <div className="progress-bar-container">
              <div
                className="progress-bar-fill"
                style={{ width: "100%" }}
              ></div>
            </div>
          </div>
          <div className="modal-body">
            <h6>Add Details</h6>
            <p>Provide specific details about what information you need</p>

            <div style={{ position: "relative" }}>
              <label>Message to Homeowner</label>
              <br />
              <textarea
                rows="4"
                cols="50"
                name="comment"
                form="usrform"
                placeholder="Please provide details about..."
                style={{ position: "relative" }}
              ></textarea>
              <img
                src={MessageHomeowner}
                alt="Message to Homeowner"
                style={{
                  width: "20px",
                  height: "20px",
                  position: "absolute",
                  top: "40px",
                  right: "15px",
                }}
              />
            </div>

            <div className="option-2">
              <h5>Selected Request Types:</h5>
              <div className="d-flex align-items-center gap-3">
                <img src={cameraIcon} alt="camera icon" />
                <span>{selectedOption}</span>
              </div>
            </div>
          </div>
          <div className="modal-footer">
            <button onClick={() => setStep(1)} className="cancel-btn">
              Back
            </button>
            <button onClick={() => finalSubmitAction()} className="next-btn">
              Send Request
            </button>
          </div>
        </>
      )}

      {step === 3 && (
        <>
          <div className="modal-header">
            <div className="header-content">
              <ArrowBackOutlinedIcon onClick={onClose} />
              <div>
                <p>Step 2 of 2</p>
                <span>Details</span>
              </div>
            </div>
            <div className="progress-bar-container">
              <div
                className="progress-bar-fill"
                style={{ width: "100%" }}
              ></div>
            </div>
          </div>
          <div className="modal-body">
            <div className="card_center">
              <div className="success-card">
                <img src={RequestSubmitted} alt="Request Submitted" />
                <h2>
                  Request Submitted
                  <br />
                  Successfully
                </h2>
                <p>
                  We'll notify you via email or push
                  <br />
                  notification when the client responds.
                </p>
                <button className="confirm-btn" onClick={onClose}>
                  Perfect, Got It!
                </button>
              </div>
            </div>
          </div>
        </>
      )}
    </div>
  );
};

export default JobResultModal;
